import React from 'react';
import * as dateFns from 'date-fns';

import { NUMBER_OF_WEEK_DAYS } from '../../../config/constants';
import { PickerHeaderProps } from './types';

const PickerCalendarHeader = ({ date, previousClick, nextClick } : PickerHeaderProps) => {
  const daysWeek = [];
  const startDate = dateFns.startOfWeek(new Date());
  for (let i = 0; i < NUMBER_OF_WEEK_DAYS; i++) {
    daysWeek.push(
      <div className='small-month-days-col' key={i}>
        {dateFns.format(dateFns.addDays(startDate, i), 'EEEEE')}
      </div>
    );
  }
  
  return (<>
    <div
      className={'cal-picker-h cal-picker-h-today'}
    >
      <div className='cal-picker-h-b cal-left' onClick={previousClick} ><i className="mdi mdi-arrow-left"/></div>
      {dateFns.format(date, 'MMMM yyyy')}
      <div className='cal-picker-h-b cal-right' onClick={nextClick} ><i className="mdi mdi-arrow-right"/></div>
    </div>
    <div className='small-month-days'>
      {daysWeek}
    </div>
  </>);
};

export default PickerCalendarHeader;